<template>
    <div>
        <div class="footer-copyright">Contact evlncrnas@163.com for inquiries and feedback. Copyright @ Dezhou University Powered By <a href="https://www.sdyunyou.cn/" target="_blank">YunyouNetwork</a></div>
    </div>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>

<style lang="less" scoped>
    .footer-copyright {
        padding: 0 60px;
        background-color: var(--theme-color);
        color: var(--lv2-color);
        font-size: 12px;
        line-height: 60px;
        a {
            color: var(--lv2-color);
        }
    }
</style>